// static text
function StaticTextComponent({ schema }) {

  return (
    <div className="prn-content-wrapper" dangerouslySetInnerHTML={{ __html: schema.html }} />
  )
}

export default StaticTextComponent;